<template>
  <!-- 运动员详情 -->
  <div class="sub-page">
    <div class="player">
      <div class="cont">
        <div class="left">
          <div class="name">运动员姓名</div>
          <div class="play-box">
            <div>
              <div class="prompt">代表队</div>
              <div class="info">代表队名称</div>
              <div class="prompt">籍贯</div>
              <div class="info">四川</div>
            </div>
            <div>
              <div class="prompt">位置</div>
              <div class="info">组织后卫</div>
              <div class="prompt">出生年月</div>
              <div class="info">2000.01.01</div>
            </div>
          </div>
        </div>
        <div class="center">
          <img src="../../../../assets/avatar.jpg" alt="" />
        </div>
        <div class="right">
          <div class="row">
            <div class="row-item">
              <div class="item-name">场均得分</div>
              <div class="item-score">21.1</div>
            </div>
            <div class="row-item">
              <div class="item-name">场均篮板</div>
              <div class="item-score">7.7</div>
            </div>
            <div class="row-item">
              <div class="item-nam">场均助攻</div>
              <div class="item-score">6.4</div>
            </div>
          </div>
          <div class="row">
            <div class="row-item">
              <div class="item-name">场均盖帽</div>
              <div class="item-score">0.1</div>
            </div>
            <div class="row-item">
              <div class="item-name">场均抢断</div>
              <div class="item-score">1.9</div>
            </div>
            <div class="row-item">
              <div class="item-nam">场均失误</div>
              <div class="item-score">5.2</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="big-title">比赛统计</div>
      <div class="row row-title">
        <div class="col-1">比赛</div>
        <div class="col-2">胜负</div>
        <div class="col-3">分钟</div>
        <div class="col-4">得分</div>
        <div class="col-5">效率值</div>
        <div class="col-6">投篮<br />出手</div>
        <div class="col-7">投篮<br />命中</div>
        <div class="col-8">投篮<br />命中率</div>
        <div class="col-9">3分<br />出手</div>
        <div class="col-10">3分<br />命中</div>
        <div class="col-11">3分<br />命中率</div>
        <div class="col-12">罚球<br />出手</div>
        <div class="col-13">罚球<br />命中</div>
        <div class="col-14">罚球<br />命中率</div>
        <div class="col-15">篮板</div>
      </div>
      <div class="row" v-for="(item, index) in rowList" :key="index" :class="index % 2 == 1 ? 'active-bg' : ''">
        <div class="col-1">
        <div>{{ item.date }}</div>  
        <div>{{ item.name }}</div>  
        </div>
        <div class="col-2">2</div>
        <div class="col-3">1</div>
        <div class="col-4">3</div>
        <div class="col-5">4</div>
        <div class="col-6">5%</div>
        <div class="col-7">积分</div>
        <div class="col-8">返10场</div>
        <div class="col-9">连胜/败</div>
        <div class="col-10">场均得分</div>
        <div class="col-11">场均失分</div>
        <div class="col-12">净胜分</div>
        <div class="col-13">主场</div>
        <div class="col-14">客场</div>
        <div class="col-15">篮板</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      rankIndex: 0,
      rowList: [
        { date:"2023-03-12",name: '山东高速  VS  福建浔兴股份' },
        { date:"2023-03-12",name: '山东高速  VS  福建浔兴股份' },
        { date:"2023-03-12",name: '山东高速  VS  福建浔兴股份' },
        { date:"2023-03-12",name: '山东高速  VS  福建浔兴股份' },
        { date:"2023-03-12",name: '山东高速  VS  福建浔兴股份' },
        { date:"2023-03-12",name: '山东高速  VS  福建浔兴股份' },
        { date:"2023-03-12",name: '山东高速  VS  福建浔兴股份' },
        { date:"2023-03-12",name: '山东高速  VS  福建浔兴股份' },
        { date:"2023-03-12",name: '山东高速  VS  福建浔兴股份' },

      ],
    }
  },
  mounted(){
    console.log(this.$route);
  },
  methods: {
    handleTab(item, index) {
      this.rankIndex = index
    },
  },
  computed: {},
}
</script>

<style lang="scss" scoped>
.sub-page {
  width: 100%;
  margin-top: 60px;
  .player {
    width: 100%;
    margin: 0 auto;
    height: 240px;
    background-color: #f8f8f8;
    color: #000000;
    .cont {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      .left {
        width: 240px;
        .name {
          font-size: 36px;
          font-weight: bold;
          margin-top: 10px;
          margin-bottom: 30px;
        }
        .play-box {
          display: flex;
          justify-content: space-between;
          .prompt {
            font-size: 14px;
          }
          .info {
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 20px;
          }
        }
      }
      .center {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 20px;
        img {
          width: 100%;
          height: 200px;
        }
      }
      .right {
        width: 240px;
        text-align: right;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        .row {
          display: flex;
          justify-content: space-between;
          .row-item {
            width: 80px;
            text-align: center;
            .item-name {
              font-size: 14px;
            }
            .item-score {
              font-size: 20px;
              font-weight: bold;
            }
          }
        }
      }
    }
  }
  .main {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 30px;
    .big-title {
      font-size: 20px;
      color: #000000;
      font-weight: bold;
      margin-top: 30px;
      margin-bottom: 15px;
    }
    .row {
      display: flex;
      justify-content: space-between;
      height: 60px;
      padding: 0 30px;
      .col-1 {
        width: 20%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-weight: bold;
      }
      .col-2 {
        width: 5%;
        line-height: 60px;
      }
      .col-3 {
        width: 5%;
        line-height: 60px;
      }
      .col-4 {
        width: 5%;
        line-height: 60px;
      }
      .col-5,
      .col-15 {
        width: 5%;
        line-height: 60px;
      }
      .col-6,
      .col-7,
      .col-8,
      .col-9,
      .col-10,
      .col-11,
      .col-12,
      .col-13,
      .col-14 {
        display: flex;
        justify-content: center;
        flex-direction: column;
        text-align: center;
      }
    }
    .active-bg {
      background-color: #e9e9e9;
    }
    .row-title {
      background-color: #000000;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/comm/components/match/basketball/components/BasketballPaylerDetail.vue